var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5047_10698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.64C17.71 1.64 22.36 6.29 22.36 12C22.36 17.71 17.71 22.36 12 22.36C6.29 22.36 1.64 17.71 1.64 12C1.64 6.29 6.29 1.64 12 1.64ZM12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.099 9.55002C14.839 9.30002 14.449 9.32002 14.199 9.56002C13.949 9.82002 13.969 10.21 14.209 10.46C14.629 10.87 14.859 11.4 14.859 11.99C14.859 12.58 14.629 13.11 14.209 13.52C13.949 13.77 13.949 14.17 14.199 14.42C14.319 14.56 14.499 14.61 14.659 14.61C14.819 14.61 14.969 14.56 15.109 14.43C15.779 13.79 16.149 12.92 16.149 11.98C16.139 11.08 15.769 10.21 15.099 9.55002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5588 7.72002C16.2988 7.49002 15.8888 7.50002 15.6588 7.77002C15.4288 8.03002 15.4388 8.44002 15.7088 8.67002C16.6488 9.52002 17.1988 10.73 17.1988 12C17.1988 13.27 16.6488 14.48 15.7088 15.33C15.4488 15.56 15.4188 15.97 15.6588 16.23C15.7788 16.37 15.9588 16.45 16.1388 16.45C16.2888 16.45 16.4388 16.4 16.5588 16.29C17.7688 15.2 18.4688 13.65 18.4688 12.01C18.4788 10.37 17.7888 8.82002 16.5588 7.73002V7.72002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0693 6.93002L8.2093 9.81002H5.9093C5.6893 9.81002 5.5293 9.99002 5.5293 10.19V13.8C5.5293 14.02 5.7093 14.18 5.9093 14.18H8.2093L12.0693 17.07C12.3293 17.26 12.6793 17.08 12.6793 16.76V7.23002C12.6793 6.92002 12.3093 6.74002 12.0693 6.93002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5047_10698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAudioIcon);
export default __webpack_public_path__ + "static/media/whiteAudioIcon.f89c11fb6e1dbcaeebacec06cb082a66.svg";
export { ForwardRef as ReactComponent };